// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const lt: KnowledgePagesCopy = {
  knowledgePage: 'Žinių puslapis',
  knowledgePages: 'Žinių puslapiai',
  featureOffTitle: 'Žinių puslapiai šioje darbo erdvėje neįjungti.',
  featureOffBody: 'Įmonės kontekstas ir šaltiniai vis dar yra skiltyje „Žinios“.',
  loadingPage: 'Įkeliamas puslapis…',
  loadingSuggestion: 'Įkeliamas pasiūlymas…',
  cancel: 'Atšaukti',
  tryAgain: 'Bandyti dar kartą',
  everyoneIn: 'Visi {company} nariai',
  yourCompany: 'jūsų įmonės',
  revision: 'Redakcija {n}',
  openRevision: 'Atidaryti redakciją {n}',
  pageCount: 'one:puslapis|few:puslapiai|many:puslapio|other:puslapių',
  topicCount: 'one:tema|few:temos|many:temos|other:temų',
  sectionCount: 'one:skyrius|few:skyriai|many:skyriaus|other:skyrių',
  lineCount: 'one:eilutė|few:eilutės|many:eilutės|other:eilučių',
  documentCount: 'one:dokumentas|few:dokumentai|many:dokumento|other:dokumentų',
  changeCount: 'one:pakeitimas|few:pakeitimai|many:pakeitimo|other:pakeitimų',
  newPageCount: 'one:naujas puslapis|few:nauji puslapiai|many:naujo puslapio|other:naujų puslapių',
  changedPageCount:
    'one:pakeistas puslapis|few:pakeisti puslapiai|many:pakeisto puslapio|other:pakeistų puslapių',
  otherSectionCount: 'one:kitas skyrius|few:kiti skyriai|many:kito skyriaus|other:kitų skyrių',
  characterCount: 'one:simbolis|few:simboliai|many:simbolio|other:simbolių',
  diffStats: 'Pakeista: {sections} · pridėta: {added} · pašalinta: {removed}',
  diffMatchesBase: 'Siūlomas tekstas sutampa su bazine redakcija.',
  diffIntroduction: 'Įžanga',
  diffOtherUnchanged: 'Be pakeitimų: {sections}.',
  timeJustNow: 'ką tik',
  originImportedFrom: 'Importuota iš {path}',
  originImportedFromCommit: 'Importuota iš {path} @ {commit}',
  authorityApprovedInPoneva: 'Patvirtinta Poneva',
  authorityImported: 'Importuota',
  authorityInRepository: '{canonicality} saugykloje',
  authorityVerified: 'patikrinta {date}',
  authorRepositoryImport: 'Importas iš saugyklos',
  authorSuggestedInChat: 'Pasiūlyta pokalbyje',
  authorSuggestedInChatWith: 'Pasiūlyta pokalbyje su {name}',
  authorSuggestedBy: 'Pasiūlė {name}',
  authorSuggestedByApp: 'Pasiūlė prijungta programa',
  authorSuggestedByColleague: 'Pasiūlė kolega',
  authorSuggestedByYou: 'Pasiūlėte jūs',
  authorSuggestedOnBehalf: '{name} vardu pasiūlė {app}',
  authorSuggestedByAppOnBehalf: '{name} vardu pasiūlė prijungta programa',
  authorSuggestedAndApproved: 'Pasiūlė ir patvirtino {name}',
  approverApprovedBy: 'patvirtino {name}',
  approverAppliedBy: 'pritaikė {name}',
  kindCreatePage: 'Naujas puslapis',
  kindUpdatePage: 'Siūlomas atnaujinimas',
  kindArchivePage: 'Archyvavimas',
  statusConflict: 'Konfliktas · puslapis pasikeitė',
  statusPending: 'Laukiama peržiūros',
  statusApproved: 'Patvirtinta',
  statusRejected: 'Atmesta',
  statusWithdrawn: 'Atšaukta',
  statusSuperseded: 'Pakeista naujesniu',
  errRevisionConflict: 'Šis puslapis pasikeitė, kol jį peržiūrėjote.',
  errProposalChanged:
    'Šis pasiūlymas pasikeitė, kol jį peržiūrėjote. Prieš priimdami sprendimą peržiūrėkite naujausią versiją.',
  errPublishRequired:
    'Tik įmonės publikuotojai gali tvirtinti žinių pakeitimus ar importuoti puslapius.',
  errProposalLimit:
    'Jūsų įmonėje jau yra 200 peržiūros laukiančių pasiūlymų. Prieš siūlydami daugiau, peržiūrėkite dalį jų.',
  errAuthorLimit:
    'Jau turite 50 peržiūros laukiančių pasiūlymų. Prieš siūlydami daugiau, palaukite, kol dėl dalies jų bus priimtas sprendimas, arba kai kuriuos atšaukite.',
  errImportProposalLimit:
    'Šis importas pridėtų daugiau peržiūrai skirtų pakeistų puslapių, nei telpa jūsų įmonės peržiūros eilėje (daugiausia 200). Priimkite sprendimus dėl kai kurių pasiūlymų skiltyje „Laukia peržiūros“ ir pritaikykite dar kartą.',
  errImportChanged:
    'Tai ne tas importas, kurį peržiūrėjote. Atidarykite jį dar kartą ir peržiūrėkite prieš pritaikydami.',
  errImportItemNotFound: 'Šis dokumentas nebėra importo dalis.',
  errIdempotencyConflict:
    'Šis pasiūlymas jau buvo išsiųstas su kitokiu turiniu. Įkelkite iš naujo ir bandykite dar kartą.',
  errImportHashMismatch:
    'Vienas šios momentinės kopijos failas neatitinka užfiksuotos kontrolinės sumos. Sukurkite momentinę kopiją iš naujo ir bandykite dar kartą.',
  errImportAlreadyApplied: 'Šis importas jau pritaikytas.',
  errImportDiscarded: 'Šis importas atmestas. Dar kartą pasirinkite momentinės kopijos failą.',
  errImportDuplicateItem:
    'Šioje momentinėje kopijoje tas pats dokumentas nurodytas du kartus. Sukurkite momentinę kopiją iš naujo.',
  errInvalidImport:
    'Poneva negalėjo priimti šios momentinės kopijos. Sukurkite ją iš naujo momentinės kopijos scenarijumi ir bandykite dar kartą.',
  errInvalidInput:
    'Poneva negalėjo priimti šių duomenų. Patikrinkite laukus ir bandykite dar kartą.',
  errImportLimit:
    'Per daug importų parengta, bet nepritaikyta. Prieš rengdami kitą, kai kuriuos pritaikykite arba atmeskite.',
  errPageTooLarge: 'Puslapis didesnis nei 256 KB. Padalykite jį į mažesnius puslapius.',
  errTooManySections:
    'Puslapyje yra daugiau nei 2 000 antraščių. Padalykite jį į mažesnius puslapius.',
  errPageLimit: 'Jūsų įmonė pasiekė 2 000 žinių puslapių ribą.',
  errCollectionLimit: 'Jūsų įmonė pasiekė 100 temų ribą.',
  errProposalNotPending: 'Dėl šio pasiūlymo jau priimtas sprendimas. Rodoma būsena yra dabartinė.',
  errRequesterRemoved:
    'Asmuo, pasiūlęs šį pakeitimą, nebėra šios įmonės narys, todėl pasiūlymo patvirtinti negalima.',
  errRevisionAlreadyCurrent: 'Ši redakcija jau yra dabartinė.',
  errPageArchived:
    'Šis puslapis buvo archyvuotas, kol jį peržiūrėjote. Prieš priimdami sprendimą dar kartą peržiūrėkite pasiūlymą.',
  errAlreadyArchived: 'Šis puslapis jau archyvuotas.',
  errProposalForbidden: 'Atšaukti šį pasiūlymą gali tik jį pateikęs asmuo.',
  errUnavailable: 'Žinių puslapiai šiuo metu nepasiekiami.',
  errTimeout: 'Poneva per ilgai neatsakė.',
  errItemTooLarge: '{path} yra didesnis nei 256 KB. Padalykite jį į mažesnius puslapius.',
  errItemTooManySections:
    'Faile {path} yra daugiau nei 2 000 antraščių. Padalykite jį į mažesnius puslapius.',
  errItemHashMismatch:
    '{path} neatitinka užfiksuotos kontrolinės sumos. Sukurkite momentinę kopiją iš naujo ir bandykite dar kartą.',
  errNoLongerAvailable: 'Šis elementas jums nebepasiekiamas.',
  errTooLargeToSend: 'Šis failas per didelis, kad būtų išsiųstas.',
  cardChecking: 'Tikrinama būsena…',
  cardNotAvailable: 'Nepasiekiama',
  cardStatusUnavailable: 'Būsena nepasiekiama',
  cardUnshowable: 'Šio siūlomo žinių atnaujinimo nepavyko parodyti.',
  cardEyebrow: 'Siūlomas žinių atnaujinimas',
  cardLabel: 'Siūlomas žinių atnaujinimas · {title}',
  cardMissing: 'Šis pasiūlymas jums nebepasiekiamas.',
  cardUnknown:
    'Nepavyko patikrinti, kokia šio pasiūlymo būsena. Atidarykite peržiūrą, kad ją pamatytumėte.',
  cardCheckAgain: 'Tikrinti dar kartą',
  cardReview: 'Peržiūrėti atnaujinimą',
  statusLineApproved: 'Patvirtintas supratimas',
  readyCount:
    'one:paruoštas paieškai|few:paruošti paieškai|many:paruošta paieškai|other:paruošta paieškai',
  preparingCount: 'one:ruošiamas|few:ruošiami|many:ruošiama|other:ruošiama',
  attentionCount: 'one:reikia dėmesio|few:reikia dėmesio|many:reikia dėmesio|other:reikia dėmesio',
  topicsExplore: 'Naršyti temą',
  topicsAllPages: 'Visi puslapiai',
  topicsOpenPages: 'Atidaryti skiltį „Puslapiai“',
  topicsEmpty:
    'Patvirtintų puslapių dar nėra. Puslapiuose saugomas išsamus įmonės supratimas su visa redakcijų istorija.',
  reviewsTitle: 'Siūlomi puslapių atnaujinimai',
  reviewsTitleMine: 'Jūsų siūlomi puslapių atnaujinimai',
  reviewsIntro:
    'Kiekvienas pasiūlymas yra išbaigta kandidatinė redakcija su priežastimi ir įrodymais. Niekas nepasikeičia, kol nepatvirtinate būtent tos redakcijos.',
  reviewsIntroMine:
    'Jūsų pasiūlymai laukia čia, kol įmonės publikuotojas juos peržiūrės. Iki tol puslapiai lieka tokie, kokie yra.',
  loadPagesFailed: 'Nepavyko įkelti žinių puslapių.',
  loadProposalsFailed: 'Nepavyko įkelti siūlomų puslapių atnaujinimų.',
  loadMoreFailed: 'Nepavyko įkelti daugiau puslapių.',
  otherPages: 'Kiti puslapiai',
  loadTopicFailed: 'Nepavyko įkelti šios temos.',
  revisionShort: 'red. {n}',
  updatedOn: 'Atnaujinta {date}',
  emptyTitle: 'Žinių puslapių dar nėra.',
  emptyBody:
    'Puslapiuose saugomas patvirtintas, išsamus jūsų įmonės supratimas – kryptis, sprendimai ir darbo būdai – kartu su kiekviena redakcija. Importuokite iš saugyklos momentinės kopijos arba pradėkite puslapį pokalbyje; publikuotojas patvirtina kiekvieną puslapį, kad jis taptų įmonės žiniomis.',
  importFromSnapshot: 'Importuoti iš saugyklos momentinės kopijos',
  startInChat: 'Pradėti puslapį pokalbyje',
  startInChatPrompt:
    'Padėkite man pradėti mūsų įmonės žinių puslapį. Paklauskite, ką jame aprašyti, ir neišgalvokite turinio. Jis liks pasiūlymu, kol įmonės publikuotojas jį patvirtins.',
  loadingPages: 'Įkeliami žinių puslapiai…',
  filterLabel: 'Filtruoti puslapius pagal pavadinimą',
  filterPlaceholder: 'Filtruoti puslapius',
  importButton: 'Importuoti',
  showingTopic: 'Rodoma tema: {topic}',
  showAllTopics: 'Rodyti visas temas',
  loadingTopic: 'Įkeliama ši tema…',
  noMatch: 'Nė vienas puslapis neatitinka „{filter}“.',
  topicNoPages: 'Šioje temoje patvirtintų puslapių dar nėra.',
  loading: 'Įkeliama…',
  loadMore: 'Įkelti daugiau puslapių',
  metaApproved: 'patvirtinta {date}',
  metaRepositoryAuthoritative: 'pagrindinis šaltinis lieka saugykla',
  loadPageFailed: 'Nepavyko įkelti šio puslapio.',
  loadHistoryFailed: 'Nepavyko įkelti redakcijų istorijos.',
  outlineLabel: 'Puslapio skyriai',
  outlineToggle: 'Šiame puslapyje',
  loadingHistory: 'Įkeliama redakcijų istorija…',
  historyLabel: 'Redakcijų istorija',
  historyIntro:
    'Kiekviena patvirtinta redakcija išsaugoma. Atkūrus ankstesnę sukuriamas pasiūlymas peržiūrai; vėlesnės redakcijos niekada neištrinamos.',
  historyCurrent: 'Dabartinė',
  historyViewing: 'Peržiūrima',
  historyView: 'Peržiūrėti',
  historyViewAria: 'Peržiūrėti redakciją {n}',
  restoreAria: 'Atkurti kaip pasiūlymą: redakcija {n}',
  restoreCreating: 'Kuriamas pasiūlymas…',
  restore: 'Atkurti kaip pasiūlymą',
  restoreUnconfirmed:
    'Nepavyko patvirtinti, kad pasiūlymas sukurtas. Prieš bandydami dar kartą patikrinkite skiltį „Laukia peržiūros“.',
  editTooLarge:
    'Šis puslapis didesnis nei 256 KB. Prieš siūlydami padalykite jį į mažesnius puslapius.',
  editConflict:
    'Šis puslapis pasikeitė, kol jį redagavote. Nukopijuokite savo tekstą, atidarykite naujausią redakciją ir pasiūlykite pakeitimą dar kartą.',
  editUnconfirmed:
    'Nepavyko patvirtinti, kad jūsų pasiūlymas išsiųstas. Prieš siųsdami dar kartą patikrinkite skiltį „Laukia peržiūros“.',
  editHeading: 'Pasiūlyti pakeitimą',
  editIntro:
    'Redaguojate redakciją {n}. Įmonės publikuotojas peržiūri tikslų pakeitimą, prieš jam tampant redakcija {next}; iki tol puslapis lieka toks, koks yra.',
  editOutdated:
    'Kol redagavote, buvo patvirtinta naujesnė redakcija. Nukopijuokite savo tekstą ir pradėkite iš naujo nuo naujausios redakcijos, kad neprarastumėte joje padarytų pakeitimų.',
  editContentLabel: 'Puslapio turinys (Markdown)',
  editReasonLabel: 'Kodėl šis pakeitimas?',
  editReasonPlaceholder: 'Kas pasikeitė ir kuo tai pagrįsta.',
  editSending: 'Siunčiama…',
  editSend: 'Siųsti peržiūrai',
  editDiscardConfirm: 'Atmesti šį pakeitimą? Niekas, ką pakeitėte, dar neišsiųsta.',
  editNoChanges: 'Pakeitimų dar nėra.',
  editNeedsContent: 'Puslapyje turi būti turinio.',
  exportFailed: 'Nepavyko eksportuoti šio puslapio. Bandykite dar kartą.',
  askPagePrompt: 'Klausimas apie žinių puslapį „{title}“ (redakcija {n}, {link}):',
  askPageSectionPrompt:
    'Klausimas apie žinių puslapį „{title}“ § {section} (redakcija {n}, {link}):',
  pageMissingTitle: 'Šis puslapis nepasiekiamas.',
  pageMissingBody: 'Galbūt jis archyvuotas arba nebeturite prieigos prie šios įmonės žinių.',
  pageArchived: 'Archyvuota',
  viewingRevisionCurrent: 'Peržiūrite redakciją {n}; dabartinė redakcija yra {current}.',
  viewingRevisionOld: 'Peržiūrite redakciją {n}. Tai nėra dabartinė redakcija.',
  openCurrent: 'Atidaryti dabartinę',
  archivedBanner: 'Šis puslapis archyvuotas. Jis nebenaudojamas atsakymams; jo istorija išsaugoma.',
  pageViewsLabel: 'Puslapio rodiniai',
  tabRead: 'Skaityti',
  tabHistory: 'Istorija',
  unknownSection: 'Susieto skyriaus šioje redakcijoje nėra. Rodomas visas puslapis.',
  askAboutPage: 'Klausti apie šį puslapį',
  exporting: 'Eksportuojama…',
  exportMarkdown: 'Eksportuoti Markdown',
  loadSuggestionFailed: 'Nepavyko įkelti šio pasiūlymo.',
  evidenceSource: 'Šaltinis',
  evidenceFact: 'Įmonės kontekstas',
  evidenceResult: 'Išsaugotas darbas',
  evidenceUrl: 'Tinklalapis',
  evidenceDecision: 'Sprendimas',
  evidenceReference: 'Nuoroda',
  evidenceOpenPage: 'Atidaryti žinių puslapį',
  evidenceOpenSource: 'Atidaryti šaltinį',
  evidenceOpenFact: 'Atidaryti įmonės kontekstą',
  evidenceOpenResult: 'Atidaryti išsaugotą darbą',
  evidenceOpenUrl: 'Atidaryti tinklalapį',
  evidenceOpenDecision: 'Atidaryti sprendimą',
  evidenceOpenReference: 'Atidaryti nuorodą',
  evidenceDecisionNote: 'Užfiksuotas sprendimas. Poneva nėra ko atidaryti.',
  evidenceFactGone: 'Šis įmonės kontekstas nebeišsaugotas.',
  evidencePageNoRevision:
    'Šis puslapis neturi patvirtintos redakcijos, kurią būtų galima atidaryti.',
  evidencePrivateExcerpt: 'Privatūs įrodymai – bendrinta tik aukščiau pateikta ištrauka.',
  evidencePrivate: 'Privatūs įrodymai – jų turinys su jumis nebendrintas.',
  evidenceHeading: 'Įrodymai',
  evidenceNone: 'Įrodymų nepridėta. Įvertinkite aukščiau nurodytą priežastį atskirai.',
  changeAdded: 'Pridėta',
  changeRemoved: 'Pašalinta',
  changeChanged: 'Pakeista',
  changeUnchanged: 'Nepakeista',
  moreLineCount:
    'one:papildoma eilutė|few:papildomos eilutės|many:papildomos eilutės|other:papildomų eilučių',
  moreUnchangedLineCount:
    'one:papildoma nepakeista eilutė|few:papildomos nepakeistos eilutės|many:papildomos nepakeistos eilutės|other:papildomų nepakeistų eilučių',
  unchangedLineCount:
    'one:nepakeista eilutė|few:nepakeistos eilutės|many:nepakeistos eilutės|other:nepakeistų eilučių',
  skipAdded: '{lines} – žr. visą redakciją',
  skipRemoved: 'Pašalinta: {lines}',
  cutUnchanged: 'Nerodoma: {lines}',
  cutChanged: 'Nerodoma: {lines} ({changes}). Patikrinkite jas visoje redakcijoje.',
  cutAddedRemoved: 'pridėta {added}, pašalinta {removed}',
  cutAdded: 'pridėta {added}',
  cutRemoved: 'pašalinta {removed}',
  lineAddedSr: 'Pridėta:',
  lineRemovedSr: 'Pašalinta:',
  noLinesAdded: 'Naujas skyrius. Jo tekstas pateiktas visoje redakcijoje žemiau.',
  noLinesRemoved: 'Šis skyrius būtų pašalintas iš puslapio.',
  noLinesChanged: 'Šis skyrius keičiasi. Jo tekstas pateiktas visoje redakcijoje žemiau.',
  diffHeading: 'Pakeitimai',
  outcomeArchived: 'Archyvuota.',
  outcomeArchivedBody:
    'Puslapis „{title}“ nebenaudojamas atsakymams ir pašalintas iš puslapių sąrašo. Jo redakcijos, šis pasiūlymas ir sprendimas lieka puslapio istorijoje.',
  openArchivedPage: 'Atidaryti archyvuotą puslapį',
  outcomeApproved: 'Patvirtinta.',
  outcomeApprovedRevision: 'Redakcija {n} dabar yra patvirtinta puslapio „{title}“ versija.',
  outcomeApprovedPlain: 'Šis pasiūlymas patvirtintas.',
  outcomeRestored: 'Puslapis grąžintas į puslapių sąrašą ir vėl naudojamas atsakymams.',
  outcomeKept: 'Pasiūlymas, sprendimas ir visos ankstesnės redakcijos lieka puslapio istorijoje.',
  openPage: 'Atidaryti puslapį',
  outcomeDismissed: 'Atmesta.',
  outcomeWithdrawn: 'Atšaukta.',
  outcomeSuperseded: 'Pakeista naujesniu.',
  outcomeSupersededBody:
    'Dėl naujesnės redakcijos, pasiūlymo ar importo iš saugyklos šis pasiūlymas tapo nebeaktualus. Pats savaime jis nieko nepakeitė.',
  outcomeUnchanged: 'Puslapis lieka toks, koks yra.',
  approveNewPage: 'Patvirtinti naują puslapį',
  approveArchive: 'Patvirtinti archyvavimą',
  approveRestoreRevision: 'Atkurti ir patvirtinti redakciją {n}',
  approveRevision: 'Patvirtinti redakciją {n}',
  approveArchiveNote: 'Patvirtinus šis puslapis bus archyvuotas visiems {company} nariams.',
  approvePublishNote: 'Patvirtinus ši redakcija bus paskelbta visiems {company} nariams.',
  approvePublishEvidenceNote:
    'Patvirtinus ši redakcija ir aukščiau rodomos įrodymų ištraukos bus paskelbtos visiems {company} nariams.',
  archivedTitle: 'Šis puslapis archyvuotas.',
  alreadyArchivedBody: 'Patvirtinimas nieko nepakeistų, todėl šį pasiūlymą galima tik atmesti.',
  archivedRestoreBody:
    'Patvirtinus puslapis bus atkurtas: su šia redakcija jis grįš į puslapių sąrašą, paiešką ir atsakymus.',
  staleRevisionAction: 'Palyginti su naujausia versija',
  staleProposalTitle: 'Šis pasiūlymas pasikeitė, kol jį peržiūrėjote.',
  staleProposalAction: 'Peržiūrėti naujausią versiją',
  staleArchivedTitle:
    'Šis puslapis buvo archyvuotas, kol jį peržiūrėjote. Patvirtinus šį pasiūlymą jis būtų grąžintas.',
  staleArchivedAction: 'Peržiūrėti dar kartą',
  suggestionMissingTitle: 'Šis pasiūlymas nepasiekiamas.',
  suggestionMissingBody:
    'Galbūt jis atšauktas arba priklauso kitam asmeniui ir nebuvo pateiktas įmonės peržiūrai.',
  decideUnconfirmed:
    'Nepavyko patvirtinti jūsų sprendimo. Rodoma naujausia Poneva būsena; prieš bandydami dar kartą ją patikrinkite.',
  decideFailed: 'Nepavyko išsaugoti jūsų sprendimo.',
  discussPrompt: 'Padėkite man patobulinti siūlomą žinių puslapio „{title}“ atnaujinimą ({link}).',
  conflictBody:
    'Šis pasiūlymas parašytas pagal redakciją {base}; dabartinė redakcija yra {current}. Jį patvirtinus tas pakeitimas būtų perrašytas, todėl tokio, koks yra, jo patvirtinti negalima.',
  conflictBodyPlain:
    'Šis pasiūlymas parašytas pagal ankstesnę redakciją, todėl tokio, koks yra, jo patvirtinti negalima.',
  openLatest: 'Atidaryti naujausią versiją',
  reworkInChat: 'Perdirbti pokalbyje',
  factReason: 'Priežastis',
  factNoReason: 'Priežastis nenurodyta.',
  factAudience: 'Auditorija',
  factRevision: 'Redakcija',
  revisionNew: 'Naujas puslapis, 1 redakcija',
  revisionArchiveAfter: 'Archyvuoti po redakcijos {n}',
  revisionWrittenAgainst: 'Parašyta pagal redakciją {base}; dabartinė redakcija yra {current}',
  revisionCurrentToProposed: 'Dabartinė redakcija {base} → siūloma redakcija {next}',
  revisionProposed: 'Siūloma redakcija {next}',
  proposedPage: 'Siūlomas puslapis',
  archivingHeading: 'Ką reiškia archyvavimas',
  archivingBody:
    'Puslapis nebenaudojamas atsakymams ir pašalinamas iš puslapių sąrašo. Jo redakcijos ir šis sprendimas išsaugomi.',
  noComparison: 'Šiam pasiūlymui skyrių palyginimas nepasiekiamas.',
  showComplete: 'Rodyti visą redakciją',
  approving: 'Tvirtinama…',
  dismissing: 'Atmetama…',
  dismiss: 'Atmesti',
  withdrawing: 'Atšaukiama…',
  withdraw: 'Atšaukti',
  editInChat: 'Redaguoti pokalbyje',
  waitingForPublisher: 'Laukiama, kol įmonės publikuotojas peržiūrės.',
  snapshotTooLarge: 'Ši momentinė kopija didesnė nei 8 MB. Sukurkite ją su mažiau dokumentų.',
  snapshotNotSnapshot:
    'Šis failas nėra žinių momentinė kopija. Pasirinkite JSON failą, kurį sukūrė momentinės kopijos scenarijus.',
  snapshotEmpty: 'Šioje momentinėje kopijoje nėra dokumentų.',
  readDocumentFailed: 'Nepavyko perskaityti šio dokumento. Bandykite dar kartą.',
  readingDocument: 'Skaitomas dokumentas…',
  hideText: 'Slėpti tekstą',
  readText: 'Skaityti tekstą',
  textOf: '„{title}“ tekstas',
  gitSnapshot: 'Git momentinė kopija {commit}',
  repositorySnapshot: 'Saugyklos momentinė kopija',
  importNewHeading: '{pages} · patvirtinama pritaikius',
  importNewNote:
    'Kiekvienas bus paskelbtas kaip patvirtintas puslapis visiems {company} nariams, be papildomos peržiūros. Prieš pritaikydami perskaitykite kiekvieną.',
  importChangedHeading: '{pages} · siunčiama peržiūrai',
  importChangedNote:
    'Kiekvienas taps siūlomu atnaujinimu. Jo puslapis pasikeis tik tada, kai publikuotojas jį patvirtins skiltyje „Laukia peržiūros“, kur rodoma, kas pasikeitė.',
  unchangedDocumentCount:
    'one:nepakeistas dokumentas|few:nepakeisti dokumentai|many:nepakeisto dokumento|other:nepakeistų dokumentų',
  unchangedNote: 'Šie dokumentai jau atitinka savo patvirtintus puslapius. Jiems nieko nerašoma.',
  stagedHeading: 'Parengta, bet nepritaikyta',
  excludedSummary: 'Į šią momentinę kopiją neįtraukta: {documents}',
  countsLine: '{newPages} · peržiūrai: {changedPages} · nepakeista: {unchanged}',
  importAlreadyDiscarded: 'Šis importas jau atmestas.',
  confirmLabel: 'Patvirtinti importą',
  unchangedKeepCount:
    'one:nepakeistas dokumentas išlaiko savo puslapį|few:nepakeisti dokumentai išlaiko savo puslapius|many:nepakeisto dokumento išlaiko savo puslapius|other:nepakeistų dokumentų išlaiko savo puslapius',
  confirmBody:
    'Pritaikyti šį importą visiems {company} nariams? Kaip 1 redakcija bus patvirtinta: {newPages}; peržiūros lauks: {changedPages}; o {unchanged}. Ankstesni šių puslapių importo pasiūlymai atšaukiami.',
  applying: 'Pritaikoma…',
  applyImport: 'Pritaikyti importą',
  chooseAnother: 'Pasirinkti kitą failą',
  allCurrent: 'Viskas šioje momentinėje kopijoje jau aktualu.',
  importApplied: 'Importas pritaikytas.',
  appliedSummary: 'Sukurta: {pages} · laukia peržiūros: {changes} · nepakeista: {unchanged}.',
  appliedIndexing:
    'Nauji puslapiai taps ieškomi pokalbyje, kai baigsis indeksavimas. Eiga rodoma skiltyje „Šaltinių paruošimas“.',
  openPages: 'Atidaryti puslapius',
  reviewChanges: 'Peržiūrėti pakeitimus ({changes})',
  checkIndexing: 'Tikrinti indeksavimo eigą',
  sendSnapshotFailed: 'Nepavyko išsiųsti šios momentinės kopijos. Bandykite dar kartą.',
  openStagedFailed: 'Nepavyko atidaryti šio parengto importo.',
  applyUnconfirmed:
    'Nepavyko patvirtinti, ar importas pritaikytas. Prieš bandydami dar kartą patikrinkite skiltį „Puslapiai“.',
  applyFailed: 'Nepavyko pritaikyti šio importo.',
  importHeading: 'Importuoti puslapius iš saugyklos',
  backToPages: 'Grįžti į puslapius',
  importLead:
    'Sukurkite momentinę kopiją komanda {command}, tada pasirinkite failą. Prieš ką nors išsaugant pamatysite kiekvieną dokumentą ir tai, ką jis pakeistų.',
  snapshotFileLabel: 'Žinių momentinės kopijos failas',
  readingSnapshot: 'Skaitoma momentinė kopija…',
  openingStaged: 'Atidaromas parengtas importas…',
  chooseSnapshot: 'Pasirinkti momentinės kopijos failą',
  factOrigin: 'Kilmė',
  factContents: 'Turinys',
  importOnlyListed: 'Importuojami tik čia išvardyti dokumentai.',
  importRepositoryAuthoritative:
    'Pagrindinis šaltinis lieka saugykla; pakeisti dokumentai tampa pasiūlymais peržiūrai.',
  overviewReviewChanges: 'Peržiūrėti pakeitimus',
  overviewConnectAgents: 'Prijungti išorinius agentus',
  overviewEyebrow: 'Bendras supratimas',
  overviewTitle: '{company} kontekste.',
  overviewLeadFallback:
    'Jūsų įmonės žinios prasideda nuo konteksto, kuriuo dalijatės. Kurkite savo verslo supratimą kartu.',
  overviewBody:
    'Įmonės kontekstas ir šaltinių medžiaga suteikia Poneva atspirties tašką, o ne viską, ką galima žinoti apie {company}. Toliau plėskite šį supratimą, kai jūsų verslas keičiasi.',
  overviewAskPrompt: 'Ką žinote apie mūsų įmonę ir ką būtų naudinga pridėti?',
  overviewAsk: 'Klausti apie {company}',
  overviewAddSources: 'Pridėti šaltinių',
  contextEyebrow: 'Kas suteikia atsakymams kontekstą',
  contextTitle: 'Verslas už klausimo.',
  contextBody:
    'Svetainių šaltiniai paaiškina viešąją verslo pusę. Įmonės pastabos papildo jūsų terminiją, prioritetus ir darbo būdą.',
  contextPrompt:
    'Padėkite man patikslinti įmonės prioritetus ir darbo įpročius, kuriuos turėtume įsiminti.',
  contextAction: 'Kurti mūsų supratimą',
  learnEyebrow: 'Erdvė mokytis',
  learnTitle: 'Pradėkite nuo to, kas svarbiausia toliau.',
  learnBody:
    'Įkelkite šaltinių medžiagos arba patikslinkite, kaip dirba jūsų įmonė. Poneva gali pasiūlyti ilgalaikių pakeitimų, kuriuos peržiūrėsite.',
  learnPrompt:
    'Remiantis esamomis mūsų įmonės žiniomis, kokios svarbios informacijos trūksta darbui, kurį norime atlikti?',
  learnAction: 'Aptarti, kas būtų naudinga',
  canvasEmptyTitle: 'Net šiek tiek konteksto labai padeda.',
  canvasEmptyBody:
    'Jūsų įmonės profilis yra atspirties taškas. Pridėkite šaltinių medžiagos ir peržiūrėtų pastabų, kad Poneva geriau suprastų jūsų darbą.',
  pageEyebrow: '{company} darbo erdvė',
  pageTitle: 'Įmonės žinios',
  pageDescription: 'Šaltiniai ir supratimas, kuriais grindžiamas Poneva darbas.',
  tabOverview: 'Apžvalga',
  tabPages: 'Puslapiai',
  tabSources: 'Šaltiniai',
  tabReview: 'Laukia peržiūros',
  proposalApproved: 'Patvirtintas įmonės kontekstas',
  proposalDismissed: 'Atmestas pasiūlymas',
  proposalRemoval: 'Siūlomas pašalinimas',
  proposalCorrection: 'Siūlomas pataisymas',
  proposalContext: 'Siūlomas įmonės kontekstas',
  proposalCurrent: 'Dabartinis supratimas',
  proposalFactGone:
    'Išsaugotas faktas nebepasiekiamas. Prieš peržiūrėdami šį pašalinimą atnaujinkite įmonės žinias.',
  proposalReviewFallback: 'Peržiūrėkite siūlomą įmonės kontekstą.',
  proposalNotSaved: 'Dar neišsaugota. Pradiniai šaltiniai lieka nepakeisti.',
  proposalWaiting: 'Laukiama peržiūros · sprendžia įmonės publikuotojas savo skiltyje „Gautieji“',
  proposalSaving: 'Išsaugoma…',
  proposalApproveRemoval: 'Patvirtinti pašalinimą',
  proposalApproveClarification: 'Patvirtinti patikslinimą',
  factLabel: 'Įmonės faktas',
  factEyebrow: 'Faktas · Visi {company} nariai',
  factSuggestCorrection: 'Pasiūlyti pataisymą',
  factAskPrompt:
    'Padėkite man suprasti arba patikslinti šį išsaugotą įmonės kontekstą: „{content}“',
  factAsk: 'Klausti apie tai',
  companyContextHeading: 'Įmonės kontekstas',
  companyContextPrompt:
    'Norėčiau patikslinti mūsų įmonės žinias. Padėkite man peržiūrėti, ką žinome, ir pasiūlyti atnaujinimą.',
  companyContextEmpty:
    'Patvirtintų pastabų dar nėra. Pradėkite pokalbį apie savo įmonę arba žemiau pridėkite šaltinių medžiagos.',
  refineInChat: 'Patobulinti pokalbyje',
  reviewPanelLabel: 'Peržiūrai skirti žinių pakeitimai',
  suggestedUpdatesHeading: 'Siūlomi atnaujinimai',
  suggestedUpdatesIntro:
    'Pasiūlymai iš jūsų pokalbių. Jūs sprendžiate, kas taps ilgalaike jūsų įmonės žinių dalimi.',
  reviewEmptyTitle: 'Niekas nelaukia jūsų peržiūros.',
  reviewEmptyBody:
    'Kai Poneva pasiūlys pakeisti jūsų įmonės žinias, pasiūlymą rasite čia. Ilgalaikiams pakeitimams visada reikia jūsų patvirtinimo.',
  reviewEmptyPrompt:
    'Padėkite man peržiūrėti mūsų įmonės žinias ir pasiūlykite, ką būtų naudinga patikslinti toliau.',
  inclusionPendingApproval: 'Įtraukimo į žinias pakeitimas išsiųstas tvirtinti.',
  sourcesFileIncluded: 'Failas įtrauktas į žinių paiešką dabartinei jo auditorijai.',
  sourcesAddFailed: 'Nepavyko pridėti šio šaltinio.',
  sourcesHeading: 'Medžiaga, kuria grindžiami atsakymai.',
  sourcesIntro:
    'Poneva ieško visoje šaltinių medžiagoje, ne tik apžvalgoje. Saugokite originalus, matykite, kas paruošta, ir pasirinkite, kas formuoja jūsų atsakymus.',
  addSourceHeading: 'Pridėkite savo įmonės medžiagos',
  addSourceIntro:
    'Įkelti šaltiniai lieka privatūs jūsų skiltyje „Biblioteka“ ir naudojami tik jūsų atsakymams. Pasirinkite „Bendrinti“, kai norėsite juos padaryti prieinamus kolegoms.',
  uploadSource: 'Įkelti šaltinį',
  addSourcePrompt:
    'Padėkite man pridėti įmonės pareiškimą kaip bendrą vidinį šaltinį. Paklauskite, ką norėčiau užfiksuoti; nieko neišgalvokite. Ilgalaikiams įmonės supratimo pakeitimams vis tiek reikia mano patvirtinimo.',
  addThroughChat: 'Pridėti per pokalbį',
  addingSource: 'Pridedama…',
  addToKnowledge: 'Pridėti prie žinių',
  uploadFormats: 'TXT, Markdown, CSV ir JSON · Iki 5 MB vienam failui',
  sourceExcluded: 'Neįtraukta į atsakymus',
  sourcePreparationFailed: 'Paruošti nepavyko',
  sourcePreparing: 'Ruošiama paieškai',
  sourceWaiting: 'Laukia paruošimo',
  sourceReadinessUnknown: 'Parengties būsena nežinoma',
  sourceRetryQueued:
    'Paruošimas įtrauktas į eilę. Parengties būsena atsinaujins, kai jis bus baigtas.',
  sourceIncludedNotice: 'Šaltinis įtrauktas. Poneva paruoš jį paieškai.',
  sourceExcludedNotice: 'Neįtraukta į atsakymus. Originalus šaltinis išsaugomas.',
  sourceUpdateFailed: 'Šio šaltinio atnaujinti nepavyko.',
  sourceOriginalMaterial: 'Originali šaltinio medžiaga',
  sourceDiscuss: 'Aptarti pokalbyje',
  sourceDiscussPrompt: 'Padėkite man suprasti arba patikslinti „{title}“.',
  sourceExclude: 'Neįtraukti į atsakymus',
  sourceInclude: 'Įtraukti į atsakymus',
  sourcesLoadFailed: 'Nepavyko įkelti jūsų šaltinių.',
  sourceLibraryLabel: 'Įmonės šaltinių biblioteka',
  sourceListCaption: 'Originalūs šaltiniai · įtraukti ir neįtraukti',
  sourceSearchLabel: 'Ieškoti įmonės šaltiniuose',
  sourceSearchPlaceholder: 'Ieškokite savo šaltiniuose…',
  sourcesFinding: 'Ieškoma jūsų šaltinių…',
  sourcePagesLabel: 'Šaltinių puslapiavimas',
  sourceRange: '{from}–{to} iš {count}',
  sourceCount: 'one:šaltinis|few:šaltiniai|many:šaltinio|other:šaltinių',
  sourcePrevious: 'Ankstesnis',
  sourceNext: 'Kitas',
  sourceNoMatchTitle: 'Atitinkančių šaltinių nėra.',
  sourceNoMatchBody: 'Pabandykite kitą frazę arba šaltinio pavadinimą.',
  sourceEmptyTitle: 'Suteikite savo klausimams tvirtesnį atspirties tašką.',
  sourceEmptyBody:
    'Pridėkite įmonės dokumentų, produktų duomenų ar darbo pastabų. Poneva gali naudoti visą šaltinių medžiagą pokalbiuose ir „Skills“.',
  indexCheckFailed: 'Nepavyko patikrinti šaltinių paruošimo.',
  indexRetryQueued:
    'Nepavykę žinių įrašai įtraukti į paruošimo eilę. Jūsų šaltinių medžiaga nepakeista.',
  indexQueueFailed: 'Nepavyko įtraukti paruošimo į eilę. Bandykite dar kartą.',
  indexPreparing: 'Ruošiamos naujos žinios jūsų pokalbiams…',
  indexAttention: 'Kai kurioms žinioms reikia dėmesio.',
  queuing: 'Įtraukiama į eilę…',
  retryPreparation: 'Ruošti dar kartą',
  sourceKindStatement: 'Įmonės pareiškimas',
  sourceKindWebsite: 'Svetainė',
  sourceKindDocument: 'Dokumentas',
  factAnswers: 'one:atsakymas|few:atsakymai|many:atsakymo|other:atsakymų',
  factUsedThisWeek: 'Naudota šią savaitę: {answers}',
  factLastUsed: 'paskutinį kartą naudota: {when}',
  factToday: 'šiandien',
  factYesterday: 'vakar',
  factImpact: 'Šis pakeitimas paveiks faktą, naudotą šią savaitę ({answers}).',
  factCorrectionAbout: 'Apie šį įmonės faktą: „{content}“ ({link})',
  factCorrectionOutdated: 'Tai jau pasenę:',
  sourceCanvasRecorded: 'Įrašyta šaltinių medžiaga',
  sourceCanvasNotIncluded:
    'Neįtraukta į įmonės žinias. Originalas saugomas kaip nuoroda ir vis dar gali būti naudojamas konkrečiame pokalbyje.',
  sourceCanvasOpenOriginal: 'Atidaryti originalų šaltinį',
  sourceCanvasUnavailable: 'Šaltinio turinys nepasiekiamas.',
  sourceCanvasDiscussPrompt: 'Padėkite man suprasti arba patikslinti „{title}“.',
  sourceCanvasDiscuss: 'Aptarti šį šaltinį',
  sourceCanvasCorrectionNote:
    'Pataisymas tampa siūlomu įmonės kontekstu. Įrašytas šaltinis lieka nepakeistas.',
  contextCanvasEyebrow: 'Prieinamas įmonės kontekstas',
  contextCanvasTitle: 'Žinios, kuriomis remiasi šis pokalbis.',
  contextCanvasBody:
    'Patvirtintas supratimas ir jūsų įmonės pridėta šaltinių medžiaga. Prieinama pokalbyje ir Skills.',
  contextCanvasOpen: 'Atidaryti „Žinios“',
};

export default lt;
